import React from 'react'
import { Image } from 'components/library'
import { Map, Layer, Popup } from './components'
import './MapWidget.css'

import mapBaseImage from './assets/map_1_overview.png'
import mapLayer1Image from './assets/map_1_overview_1.svg'
//import mapLayer2Image from './assets/map_1_overview_2.svg'
import mapLayer3Image from './assets/map_1_overview_3.svg'
import mapLayer4Image from './assets/map_1_overview_4.svg'
import mapLayer5Image from './assets/map_1_overview_5.svg'
import mapLayer6Image from './assets/map_1_overview_6.svg'
import mapLayer7Image from './assets/map_1_overview_7.svg'
import img01 from './assets/map_1_overview.png'

const Tabs = [
  { center: [2899,4249], zoom: -1.15, label: 'Rijbanen', },
  { center: [2846,4393], zoom: -0.3, label: 'Pieren', },
  { center: [2830,4292], zoom: -1, label: 'Baaien', },
  { center: [2672,4497], zoom: 1, label: 'Vliegtuigopstelplaatsen', },
  { center: [2224,4200], zoom: -2, label: 'Test', },
]

class MapWidget extends React.Component {
  state = {
    currentTab: 0,
    currentSubtab: 0,
  }

  handleChangeTab = (tab, idx) => {
    this.setState({
      currentTab: idx,
      currentSubtab: 0,
    }, () => {
      this.map.setView(tab.center, tab.zoom)
    })
  }

  handleChangeSubtab = tabIndex => {
    this.setState({ currentSubtab: tabIndex })
  }

  render() {
    return (
      <div className="Map-widget">
        <div className="Map-widget-menu">
          {Tabs.map((item, idx) => (
            <a key={idx} onClick={() => this.handleChangeTab(item, idx)}
              className={`${this.state.currentTab === idx ? 'active' : ''}`}>{item.label}</a>
          ))}
        </div>

        <div className="Map-widget-map">
          <div className="Map-widget-map-overlay">
            {this.state.currentTab === 0 &&
              <div className="Map-widget-tabs">
                <a onClick={() => this.handleChangeSubtab(0)} className={`${this.state.currentSubtab === 0 ? 'active' : ''}`}>Het landingsterrein van Schiphol kent verschillende rijbanen.</a>
                <a onClick={() => this.handleChangeSubtab(1)} className={`${this.state.currentSubtab === 1 ? 'active' : ''}`}>Als pushbackchauffeur beweeg je je alleen op en binnen het gebied van rijbaan A.</a>
                <a onClick={() => this.handleChangeSubtab(2)} className={`${this.state.currentSubtab === 2 ? 'active' : ''}`}>De benaming van de verschillende rijbanen in het terrein zijn aangegeven met location signs.</a>
              </div>
            }

            {this.state.currentTab === 1 &&
              <div className="Map-widget-tooltip">
                <p>Een pier is een uitgestrekt deel van de terminal waaraan de gates en VOP’s zich bevinden. Om aan te geven welke VOP bij welke pier wordt bedoeld, krijgt op Schiphol de pier een letter toegewezen en de VOP een cijfer. Bijvoorbeeld VOP D12 bevindt zich aan Pier D en is de 12e VOP.</p>
              </div>
            }
          </div>
          <div className="Map-widget-map-base">
            <Map getMap={map => this.map = map} options={{
              center: Tabs[0].center,
              zoom: Tabs[0].zoom,
              maxBounds: [[0, 0], [7936, 7936]],
            }}>
              <Layer url={mapBaseImage} bounds={[[0, 0], [7936, 7936]]} />

              {this.state.currentTab === 0 &&
                <React.Fragment>
                  {this.state.currentSubtab === 0 &&
                    <Layer url={mapLayer7Image} bounds={[[0, 0], [7936, 7936]]} />
                  }

                  {this.state.currentSubtab === 1 &&
                    <React.Fragment>
                      <Layer url={mapLayer3Image} bounds={[[0, 0], [7936, 7936]]} />

                      <Popup position={[2325, 4195]}>
                        <p><b>Rijbaan A</b></p>
                      </Popup>
                    </React.Fragment>
                  }

                  {this.state.currentSubtab === 2 &&
                    <React.Fragment>
                      <Layer url={mapLayer3Image} bounds={[[0, 0], [7936, 7936]]} />

                      <Popup position={[2932, 4837]}>
                        <p><b>Location sign Rijbaan A</b></p>
                        <Image src={img01} />
                      </Popup>
                    </React.Fragment>
                  }
                </React.Fragment>
              }

              {this.state.currentTab === 1 &&
                <Layer url={mapLayer4Image} bounds={[[0, 0], [7936, 7936]]} />
              }

              {this.state.currentTab === 2 &&
                <Layer url={mapLayer5Image} bounds={[[0, 0], [7936, 7936]]} />
              }

              {this.state.currentTab === 3 &&
                <Layer url={mapLayer6Image} bounds={[[0, 0], [7936, 7936]]} />
              }

              {this.state.currentTab === 4 &&
                <React.Fragment>
                  <Layer url={mapLayer1Image} bounds={[[0, 0], [7936, 7936]]} />

                  <Popup position={[1652, 3272]}>
                    <p>- kijkrichting <b>noordoostelijk</b>
                      <br/>- ligging op kompasroos: 0570
                      <br/>- naar boven afgerond: 060
                      <br/>- laatste cijfer vervalt: <b>06</b></p>
                  </Popup>

                  <Popup position={[2734, 5009]}>
                    <p>- kijkrichting <b>noordoostelijk</b>
                      <br/>- ligging op kompasroos: 0570
                      <br/>- naar boven afgerond: 060
                      <br/>- laatste cijfer vervalt: <b>06</b></p>
                  </Popup>
                </React.Fragment>
              }
            </Map>
          </div>
        </div>
      </div>
    )
  }
}

export default MapWidget



// WEBPACK FOOTER //
// ./src/components/library/widgets/map/MapWidget_full.js